import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_Locker } from "../../shared/data.service";
import { LockerImportPreviewRequest } from "../../shared/LockerImportPreviewRequest";
import { LockerImportRequest } from "../../shared/LockerImportRequest";
import { StudentImportPreviewRequest } from "../../shared/StudentImportPreviewRequest";

@Component({
	selector: "app-import-lockers",
	templateUrl: "./import-lockers.component.html",
	styleUrls: ["./import-lockers.component.css"],
})
export class ImportLockersComponent implements OnInit {
	constructor(private LockerService: DataService_Locker, private confirmationService: ConfirmationService, private ref: DynamicDialogRef) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.loadFormatOptions();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	ImportFile: any;
	ImportData: any;

	LoadingOptions: any = false;
	FormatOptionID: any = 1;
	lstFormatOptions: any = [];

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedLocker: any;
	lstLocker: any = [];

	//Filter lists
	lstStudentActiveDesc: any = [];
	lstSchoolName: any = [];
	lstValidEntryDesc: any = [];
	lstProgressDesc: any = [];

	//Cols
	cols1: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "LockerNum", header: "Locker" },
		{ field: "LockerComments", header: "Locker" },
		{ field: "AssignedComments", header: "Locker" },
		{ field: "StudentID", header: "Student ID" },
		{ field: "StudentName", header: "Name" },
	];

	cols2: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "SchoolName", header: "School" },
		{ field: "ValidEntryDesc", header: "Valid Entry" },
		{ field: "ProgressDesc", header: "Progress" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	// loadLocker(){
	//     var result = this.ImportService.LoadLocker("PARMSLIST");
	//     result.subscribe(
	//         response => {
	//             this.lstLocker = response;

	//             //Load Data Filter Lists
	//     this.lstStudentActiveDesc = Array.from(new Set(this.lstLocker.map((item: any) => item.StudentActiveDesc)));
	//     this.lstSchoolName = Array.from(new Set(this.lstLocker.map((item: any) => item.SchoolName)));
	//     this.lstValidEntryDesc = Array.from(new Set(this.lstLocker.map((item: any) => item.ValidEntryDesc)));
	//     this.lstProgressDesc = Array.from(new Set(this.lstLocker.map((item: any) => item.ProgressDesc)));

	//         },
	//         error => {
	//         }
	//     )
	// }

	loadFormatOptions() {
		this.LoadingOptions = true;

		var result = this.LockerService.LockerFormatSelectList();
		result.subscribe(
			(response) => {
				this.LoadingOptions = false;

				this.lstFormatOptions = response;

				for (var z = 0; z < this.lstFormatOptions.length; z++) {
					var next = this.lstFormatOptions[z];

					if (next.Selected == true) {
						this.FormatOptionID = next.ID;
						break;
					}
				}
			},
			(error) => {
				this.LoadingOptions = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onSelectFile() {
		this.errorMessage = "";

		document.getElementById("ImportInput").click();
	}

	onFileToImportChange(val) {
		// console.log("Import File Changed");
		// console.log(val);

		this.ImportFile = val.target.files[0];

		// console.log("Import File");
		// console.log(this.ImportFile);

		var fr = new FileReader();
		fr.readAsDataURL(this.ImportFile);

		fr.onload = () => {
			this.ImportData = fr.result;
			this.FinishLoadFile();
		};
	}

	FinishLoadFile() {
		// this.ImportData = f;

		let parms: LockerImportPreviewRequest = {
			FormatOption: this.FormatOptionID,
			Base64File: this.ImportData,
		};

		var result = this.LockerService.LoadImportPreviewData(parms);
		result.subscribe(
			(response) => {
				this.lstLocker = response;

				for (var z = 0; z < this.lstLocker.length; z++) {
					var next = this.lstLocker[z];

					next.UID = z;
				}

				//Load Data Filter Lists
				this.lstStudentActiveDesc = Array.from(new Set(this.lstLocker.map((item: any) => item.StudentActiveDesc))).sort();
				this.lstSchoolName = Array.from(new Set(this.lstLocker.map((item: any) => item.SchoolName))).sort();
				this.lstValidEntryDesc = Array.from(new Set(this.lstLocker.map((item: any) => item.ValidEntryDesc))).sort();
				this.lstProgressDesc = Array.from(new Set(this.lstLocker.map((item: any) => item.ProgressDesc))).sort();

				this.LoadImportData();
			},
			(error) => {}
		);
	}

	LoadImportData() {
		let lstSchool: string[] = [];
		let lstStudent: string[] = [];

		lstSchool = Array.from(new Set(this.lstLocker.map((item: any) => item.SchoolNumber)));
		lstStudent = Array.from(new Set(this.lstLocker.map((item: any) => item.StudentID)));

		let parms: StudentImportPreviewRequest = {
			lstSchoolNums: lstSchool,
			lstStudentIDs: lstStudent,
		};

		var result = this.LockerService.LoadImportPreviewAll(parms);
		result.subscribe(
			(response) => {
				// console.log(response[0]);
				// console.log(response[0].schoolInfo);
				// console.log(response[0].studentInfo);

				var schoolInfo: any = response[0].schoolInfo;
				var studentInfo: any = response[0].studentInfo;

				// for(var z = 0; z < schoolInfo.length; z++){
				//   var next = schoolInfo[z];
				//   console.log(next);
				// }

				// var SchoolData = new Map();
				// var StudentData = new Map();

				for (var z = 0; z < this.lstLocker.length; z++) {
					var next = this.lstLocker[z];

					try {
						var SchoolEntry: any = schoolInfo[next.SchoolNumber];
						next.SchoolName = SchoolEntry.SchoolName;
						next.SchoolID = SchoolEntry.SchoolID;
					} catch (e) {
						e.toString();
					}

					if (next.StudentID != "") {
						try {
							var StudentEntry: any = studentInfo[next.StudentID];
							next.PersonID = StudentEntry.PersonID;
							next.StudentName = StudentEntry.StudentName;
							next.StudentActive = StudentEntry.StudentActive;
							next.StudentActiveDesc = StudentEntry.StudentActiveDesc;
						} catch (e) {
							e.toString();
						}
					}

					next.ProgressInt = 2;
					next.ProgressDesc = "Loaded";

					var SchoolValid: boolean = false;
					var StudentValid: boolean = false;

					if (SchoolEntry != undefined && next.SchoolID != undefined && next.SchoolID > 0) {
						SchoolValid = true;
					}
					if (next.StudentID == "" || (next.StudentID != "" && next.PersonID != undefined && next.PersonID > 0)) {
						StudentValid = true;
					}

					next.ValidEntry = SchoolValid && StudentValid;
					next.ValidEntryDesc = next.ValidEntry == true ? "Valid" : "Invalid";
				}

				this.lstStudentActiveDesc = Array.from(new Set(this.lstLocker.map((item: any) => item.StudentActiveDesc)));
				this.lstSchoolName = Array.from(new Set(this.lstLocker.map((item: any) => item.SchoolName)));
				this.lstValidEntryDesc = Array.from(new Set(this.lstLocker.map((item: any) => item.ValidEntryDesc)));
				this.lstProgressDesc = Array.from(new Set(this.lstLocker.map((item: any) => item.ProgressDesc)));
			},
			(error) => {}
		);
	}

	onFinishImport() {
		//
		// Create Request
		//

		var lstValid: any = [];
		lstValid = Array.from(this.lstLocker).filter((locker: any) => locker.ValidEntry == 1 && locker.SchoolID != undefined);

		// console.log(lstValid);

		var lstSIDs: number[] = [];
		var lstPIDs: number[] = [];
		var lstLNums: string[] = [];
		var lstLCom: string[] = [];
		var lstACom: string[] = [];

		for (var z = 0; z < lstValid.length; z++) {
			var next = lstValid[z];

			lstSIDs = [...lstSIDs, next.SchoolID];
			lstPIDs = [...lstPIDs, next.PersonID];
			lstLNums = [...lstLNums, next.LockerNum];
			lstLCom = [...lstLCom, next.LockerComments];
			lstACom = [...lstACom, next.AssignedComments];
		}

		let parms: LockerImportRequest = {
			lstSchoolIDs: lstSIDs,
			lstPersonIDs: lstPIDs,
			lstLockerNums: lstLNums,
			lstLockerComments: lstLCom,
			lstAssignedComments: lstACom,
		};

		var result = this.LockerService.LockerFinishImport(parms);
		result.subscribe(
			(response) => {
				if (this.AllClear(response) == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "import",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Lockers were imported successfully. Lockers were created, updated, assigned, and unassigned based on the import data.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "import",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not import lockers: " + response,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onFormatOptionIDChange(val) {
		this.FormatOptionID = val;

		if (this.ImportData != undefined) {
			this.FinishLoadFile();
		}
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedLocker = val.data;
	}
	onRowUnselect(val) {
		this.SelectedLocker = null;
	}
	onRowDblClick(Locker) {
		this.SelectedLocker = Locker;
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.LoadingOptions == true;
	}

	AllClear(lstResp) {
		var ans = true;

		for (var z = 0; z < lstResp.length; z++) {
			var next = lstResp[z];

			if (next != "") {
				// Error message found
				ans = false;
				break;
			}
		}

		return ans;
	}

	////////////////////////////////////////////
}
